import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';
import { first, shareReplay } from 'rxjs';
import { Table } from 'primeng/table';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-crop-master-status',
  templateUrl: './crop-master-status.component.html',
  styleUrls: ['./crop-master-status.component.scss'],
  providers: [DatePipe],
})
export class CropMasterStatusComponent implements OnInit {

  @ViewChild('cropMasterTable', { static: true })
  public cropMasterTable: Table;

  public userId: any;
  public canalMasterData: any = [];
  public subscriptions: any = []
  public subjectSub: any;
  public selectedYear: any;
  public loading: boolean = false;
  public ipAddress: any;
  public showDialogToUpdateStatus: any;
  public selectedCrop: any;
  public isSubmitted: boolean = false;
  updateStatusForm: FormGroup;
  menuItems: MenuItem[];
  appVerificationItems: MenuItem[];
  
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  // appVerificationItems: MenuItem[];
  // cols: (
  //   | { field: string; header: string; customExportHeader: string }
  //   | { field: string; header: string; customExportHeader?: undefined }
  // )[];
  // exportColumns: { title: string; dataKey: string }[];

  constructor(
    private service: BaseService,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    private _personalDetalSer: FarmersDetailsService, 
    private _fb: FormBuilder,
    private datePipe: DatePipe,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    this.getIP();
    this.loadDataAndApplyFilter();
    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.canalMasterData, "Crop Master Report");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.canalMasterData, "Crop Master Report");
      //   }
      // },
    ];

    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.canalMasterData, "Crop Master Report");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.canalMasterData, "Crop Master Report");
      //   }
      // },
    ];

    this.updateStatusForm = this._fb.group({
      documentID: ['', Validators.required],     
      documentPath: ['', Validators.required],
      fromDate: ['', Validators.required],
      endDate: ['', Validators.required],
      area: ['', Validators.required],
    });

    // this.appVerificationItems = [
    //   {
    //     label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
    //       this.exportExcel(this.canalMasterData, "Vendor_MI_Estimation_List");
    //     }
    //   },
    //   {
    //     label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
    //       this.downloadSheetAsPdf(this.canalMasterData, "Vendor_MI_Estimation_List");
    //     }
    //   },
    // ];

  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  get updateStatusFormControls() {
    return this.updateStatusForm.controls;
  }

  loadDataAndApplyFilter() {
    if (sessionStorage.getItem('financialYear')) {
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {


        this.selectedYear = res;
        this.loadData();
        // this.cropMasterTable.filters['FinYear'] = [
        //   { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  loadData() {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    // this.vendorRegId = JSON.stringify(token?.officeCode);

    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getCropMasterStatus()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Update Crop Status', '', new Date(), 'Success');

          this.userId = JSON.parse(payload)?.sub;


          if (data.length > 0) {
            this.canalMasterData = data;
          }
          else {
            this.canalMasterData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Update Crop Status', '', new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  updateAction(val) {
    // let textVal = val?.Status == 'Open' ? 'close' : 'open';
    // this.confirmationService.confirm({
    //   message: `<b>Want to ${textVal} for ${val?.Crop_Name} crop?</b>`,
    //   header: 'Confirm',
    //   icon: 'pi pi-exclamation-triangle',
    //   accept: () => {
    //     let reqBody = {
    //       CropId: val?.Crop_ID,
    //       Status: val?.Status == 'Open' ? 0 : 1,
    //       NetworkId: this.ipAddress,
    //       TerminalId: this.ipAddress
    //     }
    //     this.updateCropStatus(reqBody);
    //   }
    // });
    this.selectedCrop = val;
    this.showDialogToUpdateStatus = true;
  }

  hideDialog(){
    this.showDialogToUpdateStatus = false;
    this.isSubmitted = false;
    this.updateStatusForm.reset();
  }

  saveProduct(){
    this.isSubmitted = true;
    if (this.updateStatusForm.valid) {
      let val = this.updateStatusForm.value;
      let reqBody = {
        CropId: this.selectedCrop?.Crop_ID,
        Status: this.selectedCrop?.Status == 'Open' ? 0 : 1,
        documentPath: val?.documentPath,
        documentID: val?.documentID,
        fromDate: val.fromDate ? this.datePipe.transform(new Date(val.fromDate), 'yyyy-MM-dd') : val.fromDate,
        endDate: val.endDate ? this.datePipe.transform(new Date(val.endDate), 'yyyy-MM-dd') : val.endDate,
        area: val?.area,
        NetworkId: this.ipAddress,
        TerminalId: this.ipAddress
      }
      this.updateCropStatus(reqBody);
    }
    
  }

  updateCropStatus(reqBody) {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));   
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loader.start();
    this.deptDashBoardService
      .updateCropStatus(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.loadData();
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: 'Status Updated Succesfully',
          });
          this.hideDialog();
          this.activityRecordService.activityRecord(this.userId, 'Update Crop Status', reqBody?.Crop_ID, new Date(), 'Success');
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userId, 'Update Crop Status', reqBody?.Crop_ID, new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    this.loader.start();
    this._personalDetalSer.uploadFile(data, this.userId, formcontrol).subscribe(
      (resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          this.updateStatusForm.patchValue({ [formcontrol]: resp.data });
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }else{
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Oops! Someting went wrong.',
          });
        }
      },
      (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    );

    uploadElement.clear();
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'Crop_Name', header: 'Crop Name' },
      { field: 'TotalApp', header: 'Total Apps' },
      { field: 'documentID', header: 'Document ID' },
      { field: 'AreaAcre', header: 'Target Area' },
      { field: 'fromDate', header: 'Start Date' },
      { field: 'endDate', header: 'End Date' },
      { field: 'Status', header: 'Status' },
      
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, this.canalMasterData);
        doc.save('Applications_Details.pdf');
      });
    });
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Crop Name":d.Crop_Name,
          "Total Apps":d.TotalApp,
          "Document ID":d.documentID,
          "Target Area":d.AreaAcre,
          "Start Date":d.fromDate,
          "End Date":d.endDate,
          "Status":d.Status,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  refreshTable() {
    this.loadData();
  }
}

